import React, { useState } from "react";

import { Icon } from "components/icon/Icon";
import Time from "common/Time";
import { captureEvent } from "components/posthog/customEventCapture";
import { Message } from "models/admin/admin";

import "./SystemMessage.scss";
import "../containers/Admin.scss";

type Props = {
  internalMessages: Message[];
  deleteSystemMessage: (messageId: string) => void;
  handleSubmit: (message: string, hours: string) => void;
  handleSubmitExternal: (message: string, hours: string) => void;
  staticSysMessage: { message: string; validUntil?: string };
  deleteExternalSystemMessage: () => void;
};

export default function SystemMessage({
  internalMessages,
  deleteSystemMessage,
  handleSubmit,
  handleSubmitExternal,
  staticSysMessage,
  deleteExternalSystemMessage
}: Props) {
  const [externalMessage, setExternalMessage] = useState<string>(
    staticSysMessage.message
  );
  const [internalMessage, setInternalMessage] = useState("");
  const [internalHours, setInternalHours] = useState("");
  const [externalHours, setExternalHours] = useState("");

  const handleMessageChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    isInternal: boolean
  ) => {
    if (isInternal) {
      setInternalMessage(e.target.value);
    } else {
      setExternalMessage(e.target.value);
    }
  };

  const handleHoursChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    isInternal: boolean
  ) => {
    if (isInternal) {
      setInternalHours(e.target.value);
    } else {
      setExternalHours(e.target.value);
    }
  };

  const onSubmit = (e: React.FormEvent, isInternal: boolean) => {
    e.preventDefault();
    const message = isInternal ? internalMessage : externalMessage;
    const hours = isInternal ? internalHours : externalHours;
    const submitAction = isInternal ? handleSubmit : handleSubmitExternal;
    const setMessage = isInternal ? setInternalMessage : setExternalMessage;
    const setHours = isInternal ? setInternalHours : setExternalHours;

    if (message && message.length > 0) {
      if (parseInt(hours) > 0) {
        submitAction(message, hours);
        setMessage("");
        setHours("");
      }
    }
  };

  const systemMessage = (
    <div className="sysMessage">
      <span>Meddelande: {staticSysMessage.message}</span>
      <div>
        Giltig till: {Time.formatLong(staticSysMessage.validUntil)}{" "}
        <Icon
          name={"trash"}
          title="Ta bort"
          onClick={deleteExternalSystemMessage}
        />
      </div>
    </div>
  );

  const internalMessageContent = (
    <ul className="notificationList">
      {internalMessages.map((messages) => {
        if (messages.notificationType === "SystemMessage") {
          return (
            <li key={messages.id}>
              {messages.message}{" "}
              <Icon
                name={"trash"}
                title="Ta bort"
                onClick={() => deleteSystemMessage(messages.id)}
              />
            </li>
          );
        }
        return <></>;
      })}
    </ul>
  );

  return (
    <div>
      <fieldset>
        <p>
          Ange <strong>INTERNT</strong> systemmeddelande. Visas för samtliga
          inloggade användare av MittKontor.
        </p>
        <textarea
          name="message"
          onChange={(e) => handleMessageChange(e, true)}
          value={internalMessage}
        />
        <br />
        <p>Ange antal timmar som systemmeddelandet ska vara giltigt.</p>
        <input
          name="hours"
          type="number"
          placeholder="Antal timmar"
          onChange={(e) => handleHoursChange(e, true)}
          value={internalHours}
        />
        {internalMessageContent}
        <button
          className="buttonSecondary"
          onClick={(e) => {
            onSubmit(e, true);
            captureEvent("Skicka");
          }}
        >
          Skicka
        </button>
      </fieldset>
      <fieldset className="sndBlock">
        <p>
          Ange <strong>EXTERNT</strong> systemmeddelande. Visas på MittKontors
          loginsida. Det kan endast vara ett aktivt externt meddelande åt
          gången.
        </p>
        <textarea
          name="messageExternal"
          onChange={(e) => handleMessageChange(e, false)}
          value={externalMessage}
        />
        <br />
        <p>Ange antal timmar som systemmeddelandet ska vara giltigt.</p>
        <input
          name="hoursExternal"
          type="number"
          placeholder="Antal timmar"
          onChange={(e) => handleHoursChange(e, false)}
          value={externalHours}
        />
        <br />
        {staticSysMessage.message === "" ||
        (staticSysMessage.validUntil &&
          new Date(staticSysMessage.validUntil) < new Date())
          ? null
          : systemMessage}
        <button
         className="buttonSecondary"
          onClick={(e) => {
            onSubmit(e, false);
            captureEvent("Spara");
          }}
        >
          Spara
        </button>
      </fieldset>
    </div>
  );
}
